import * as React from 'react';
import { MDXRenderer } from "gatsby-plugin-mdx";
export var MarkdownBlock = function MarkdownBlock(_ref) {
  var className = _ref.className,
      children = _ref.children,
      frontmatter = _ref.frontmatter,
      featuredImage = _ref.featuredImage;
  return /*#__PURE__*/React.createElement("div", {
    className: "markdown-block " + (className ? className : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(MDXRenderer, {
    frontmatter: frontmatter,
    featuredImage: featuredImage
  }, children)));
};